"use strict";

exports.__esModule = true;
exports.ErrorBoundary = void 0;
var _react = _interopRequireWildcard(require("react"));
var _UhOh = require("../UhOh");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Shows an UhOh if a child component throws an error.
 */
var ErrorBoundary = exports.ErrorBoundary = /*#__PURE__*/function (_Component) {
  function ErrorBoundary() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      error: undefined
    };
    _this.clearError = function () {
      _this.setState({
        error: undefined
      });
    };
    return _this;
  }
  _inheritsLoose(ErrorBoundary, _Component);
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, info) {
    this.setState({
      error: error
    });
    console.error(error, info);
  };
  _proto.render = function render() {
    var error = this.state.error;
    if (error !== undefined) {
      return /*#__PURE__*/_react["default"].createElement(_UhOh.UhOh, {
        error: error,
        onReload: this.clearError
      });
    }
    var children = this.props.children;
    return children;
  };
  return ErrorBoundary;
}(_react.Component);